import type { ReactNode } from 'react'

/** A single card in the middle of the window, for the steps before there is a dashboard. */
export function Centered({ children }: { children: ReactNode }) {
  return (
    <div style={{ height: '100%', display: 'grid', placeItems: 'center', padding: 24 }}>
      {children}
    </div>
  )
}
